import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { Bound } from "lib/@components/binding/Bound"
import { TailoredAudits } from "./tailored-audits"
import { IntroSubjectJustificationBody } from "./intro-subject-justification-body"
import { isTailoredScheduleAuditingEnabled } from "./lib/is-tailored-schedule-auditing-enabled"

// Mounts justification (icon + card + auto-save) for a single intro subject — the introduction body
// (`subjectId="intro"`) or its notes (`subjectId="introNote"`). Tailoring normally can't touch the
// intro, but the content-override feature lets it, so these get justifications like tasks do. Audits are
// loaded via the same TailoredAudits loader the task list uses (bound to the schedule item), keyed by
// the synthetic subject id. No-ops unless tailored-schedule-auditing is enabled.
export function IntroSubjectJustification({ subjectId, subjectTitle, part, field }) {
    const { scheduleItem } = useBoundContext()

    if (!isTailoredScheduleAuditingEnabled() || !scheduleItem) return null

    return (
        <Bound
            target={scheduleItem}
            subjectId={subjectId}
            subjectTitle={subjectTitle}
            part={part}
            overrideField={field}
        >
            <TailoredAudits>
                <IntroSubjectJustificationBody />
            </TailoredAudits>
        </Bound>
    )
}
